import { ChannelType } from 'components/CampaignCreationModal/Types'
import { useModals } from 'almanac-ui/Modal'
import { ArticleAIGeneratedEvent } from 'components/ActivityEvent/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { DoubleArrowsExpand } from 'almanac-ui/icons'
import { schemas } from 'components/Wizards/schemas/schemas'
import { RetryWizard } from 'components/Wizards/RetryWizard/RetryWizard'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { RetryBlogPostWizard } from 'components/Wizards/RetryBlogPostWizard/RetryBlogPostWizard'
import { RetryYoutubeScriptWizard } from 'components/Wizards/RetryYoutubeScriptWizard/RetryYoutubeScriptWizard'
import { object, StringSchema } from 'yup'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useBrandVoices } from 'hooks/useBrandVoices'
import { shouldRenderPrompt } from 'components/ActivityEvent/utils'
import { Button } from 'blaze-ui/Button'
import { ButtonProps } from 'blaze-ui/Button/Types'

export enum NonChannelWizard {
  Brainstorm = GenerationType.Brainstorm,
  ContentBrief = GenerationType.ContentBrief,
  Outline = GenerationType.Outline,
}

const WizardMap: { [key in ChannelType]?: React.FunctionComponent<React.PropsWithChildren<any>> } = {
  [ChannelType.BlogPost]: RetryBlogPostWizard,
  [ChannelType.YoutubeScript]: RetryYoutubeScriptWizard,
}

interface Props {
  event: ArticleAIGeneratedEvent
  title?: string
}

export const EventWizardButton = ({
  event,
  title = 'Open Wizard',
  variant = 'tertiary',
  size = 'md',
}: Props & Pick<ButtonProps, 'variant' | 'size'>) => {
  const { openModal, closeModal } = useModals()
  const { currentFolder } = useCurrentFolderStore()
  const currentWorkspace = useCurrentWorkspace()
  const { data: voices } = useBrandVoices(currentWorkspace)

  const Wizard = WizardMap[event.data.generation_type as ChannelType] || RetryWizard

  const handlePress = () => {
    const schema = schemas[event.data.generation_type as ChannelType]
    const topicSchema = (schema.fields as { topic?: StringSchema }).topic
    openModal(Wizard, {
      schema: schemas[event.data.generation_type as ChannelType].concat(
        object({ topic: topic.meta({ ...(topicSchema?.describe().meta || {}), copyToClipboard: true }) }),
      ),
      initialValues: {
        brandVoiceId: voices?.[voices.length - 1]?.id,
        ...event.data,
        topic: shouldRenderPrompt(event.data?.topic) ? event.data.topic : '',
        project: currentFolder,
      },
      articleId: event.article.key,
      layerId: event.layer.id,
      onSuccess: closeModal,
    })
  }

  return (
    <Button onPress={handlePress} variant={variant} size={size} frontIcon={DoubleArrowsExpand} aria-label="Open Wizard">
      {title}
    </Button>
  )
}
